export const PHONE_MAX_LENGTH = 15 + 1;
export const TIMEOUT_STORAGE_KEY = 'phoneTimeoutData';
export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const TIMEOUT_DURATION = 2 * MINUTE; // 2 минуты
